import { Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { OfficeService } from "../services/office.service";
import { CurrentUser } from "../models/current-user.model";
import { ROUTE_PATH } from "../constants/route-path";
import { Office } from "../models/office.model";
import { Company } from "../models/company.model";
import { MapService } from "../services/map.service";
import { SessionStorageKey } from "../constants/session-storage-key";
import { FloorInfoService } from "../services/floorinfo.service";

export class LoginHelper {

  /**
   * Opens the previous URL of the session. navigateByUrl() is used when the URL carries a query
   * string, because navigate() would encode it as part of the path.
   */
  private static navigateToPrevUrl(router: Router, prevUrl: string): Promise<boolean> {
    return prevUrl.includes('?') ? router.navigateByUrl(prevUrl) : router.navigate([prevUrl]);
  }

  public static async loginOffice(authService: AuthenticationService, officeService: OfficeService, mapService: MapService,router: Router, userInfo: CurrentUser, offices: Office, quickLogin: boolean = false, floorInfoService: FloorInfoService) {
    let orid = authService.getOrgId();
    let company = userInfo.listcompany?.filter(c=>c.organizationId === orid).find(c => c.code === offices.officecd);
    authService.setMapId(offices.listmapid?.[0] ?? '');
    authService.handleLoginSuccess(userInfo, authService.getMapId() ?? '', company?.organizationId ?? 0, company?.organizationCode ?? '', company?.id ?? 0, offices);
    await officeService.saveLastLogin(userInfo?.userId?.toString() ?? '0', (company?.id ?? 0).toString());
    let lstmap = await mapService.getMapList([authService.getMapId() ?? '']);
    const lstmapData = await Promise.all(
      (lstmap ?? []).map(async (map) => {
        const lstfloor = await floorInfoService.getFloorByMap(map.mid ?? '') ?? [];
        return { ...map, listfloor: lstfloor };
      })
    );
    mapService.setLstMapManagerValue(lstmapData);
    if (authService.prevUrlValue) {
      if(quickLogin){
        if(authService.prevUrlValue.includes('map') && lstmap!.length == 0)
          // router.navigate([`${ROUTE_PATH.TAG}/${ROUTE_PATH.USERTAG}`]).then(() => { authService.setprevUr(null) }).then(() => { window.location.reload() });
          router.navigate([ROUTE_PATH.NO_MAP]).then(() => { authService.setprevUr(null) }).then(() => { window.location.reload() });
        else LoginHelper.navigateToPrevUrl(router, authService.prevUrlValue).then(() => { authService.setprevUr(null) }).then(() => { window.location.reload() });
      }else LoginHelper.navigateToPrevUrl(router, authService.prevUrlValue).then(() => { authService.setprevUr(null) });
    } else {
      // if(lstmap!.length == 0) router.navigate([`${ROUTE_PATH.TAG}/${ROUTE_PATH.USERTAG}`]).then(() => { authService.setprevUr(null) })
      if(lstmap!.length == 0) router.navigate([ROUTE_PATH.NO_MAP]).then(() => { authService.setprevUr(null) })
      else router.navigate([ROUTE_PATH.MAP]).then(() => { authService.setprevUr(null) })
    }
  }

  public static async loginOrg(authService: AuthenticationService, officeService: OfficeService, mapService: MapService, floorInfoService: FloorInfoService, router: Router, userInfo: CurrentUser, comp: Company): Promise<boolean> {
    authService.setOrgId(comp.organizationId ?? 0);
    authService.setOrgCd(comp.organizationCode ?? '');

    //Temporarily set for login schema
    authService.setCompanyId(comp.id ?? 0);

    //this.pageLoadingService.showLoading();
    let lstCompIds = userInfo.listcompany?.filter(c=>c.organizationId === comp.organizationId).map(c => c.id?.toString() || '') || []
    let offices: Office[] = [];
    try {
      offices = (await officeService.getListOfficeByCompany(lstCompIds, (comp.organizationId ?? 0).toString())) ?? [];
      sessionStorage.setItem(SessionStorageKey.OFFICES, JSON.stringify(offices));
    }
    catch (err) { }

    //this.pageLoadingService.hideLoading();
    if (!offices || offices.length == 0) {
      //this.loginError();
      return false;
    }
    else if (offices.length == 1) {
      await LoginHelper.loginOffice(authService, officeService, mapService, router, userInfo, offices[0], false, floorInfoService);
    }
    else {
      authService.setListOffice(offices || []);
      router.navigate([ROUTE_PATH.CHOOSE_OFFICE]);
    }
    return true;
  }
}
